// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2z6iP","messages":"Chat_messages__2Q8FR","dateDivider":"Chat_dateDivider__3NC3k"};